export const googleCalendarEn = {
  onlyMyTasks: 'Only my tasks',
  allTasks: 'All tasks',
  notConfigured: 'Not configured',
  synchronizationIsNotSet: 'Synchronization is not configured',
  whatWillBeSent:
    'You haven’t configured what will be sent to your Google calendar',
  tasksAdded: 'Tasks added successfully!',
  allNewWillBeSent:
    'All new tasks will be transferred from YouGile to the calendar.',
  errorTryAgain: 'Error. Try again later',
  requiredField: 'Required field',
  errorRetrievingData: 'Error while retrieving data from Google Calendar.',
  setupAgain: 'Reset',
  integrationWithGoogleCalendar: 'Integration with Google Calendar',
  isEnabled: 'is enabled.',
  primaryCalendar: 'Your main calendar'
}

export const googleCalendarRu: typeof googleCalendarEn = {
  onlyMyTasks: 'Только мои задачи',
  allTasks: 'Все задачи',
  notConfigured: 'Не настроено',
  synchronizationIsNotSet: 'Синхронизация не настроена',
  whatWillBeSent:
    'Вы не настроили что будет передаваться в ваш Google-календарь',
  tasksAdded: 'Задачи успешно добавлены!',
  allNewWillBeSent:
    'Все новые задачи будут передаваться из YouGile в календарь.',
  errorTryAgain: 'Ошибка. Попробуйте снова',
  requiredField: 'Обязательное поле',
  errorRetrievingData: 'Ошибка при получении данных из Google Календаря.',
  setupAgain: 'Настроить заново',
  integrationWithGoogleCalendar: 'Интеграция с Google-календарём',
  isEnabled: 'подключена.',
  primaryCalendar: 'Ваш основной календарь'
}
